import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { FormMenuItemsResponse, UIDefinitionResponse } from "../types/FormMenuItemsResponse"

const { cmApiBaseUrl } = getPublicConfig()
const uiDefinitionsApiBaseUrl = `${cmApiBaseUrl}/v1/ui_definitions`

export const createUiDefinitionsApi = (client: HttpClient) => ({
  getFormMenuItems: async (customerId?: string): Promise<FormMenuItemsResponse> => {
    // Build URL directly to preserve camelCase (backend expects camelCase query params)
    const url = customerId
      ? `${uiDefinitionsApiBaseUrl}/menu_titles?customerId=${encodeURIComponent(customerId)}`
      : `${uiDefinitionsApiBaseUrl}/menu_titles`
    return client.get<FormMenuItemsResponse>(url)
  },

  getUIDefinition: async (id: string, customerId: string): Promise<UIDefinitionResponse> => {
    // Build URL directly to preserve camelCase (backend expects camelCase query params)
    const url = `${uiDefinitionsApiBaseUrl}/${id}?customerId=${encodeURIComponent(customerId)}`
    return client.get<UIDefinitionResponse>(url)
  }
})
